module.exports = __webpack_public_path__ + "static/img/serviceImg.f2b8742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceImg.png
// module id = /2OE
// module chunks = 1